import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Account } from '../../../models/account';
import { AuthenticationService } from '../../../services/authentication.service';
import { TimeZoneService } from '../../../services/timeZone.service';
import { EventViewModel } from '../../../viewModels/events/eventViewModel';
import moment from 'moment';

@Component({
    selector: 'app-filters-live-event-entry',
    templateUrl: './filters-live-event-entry.component.html',
    styleUrls: ['./filters-live-event-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FiltersLiveEventEntryComponent implements OnInit {
  @Input() event: EventViewModel;
  @Input() selected: boolean;

  @Output() eventSelected = new EventEmitter<EventViewModel>();

  account: Account;

  constructor(private readonly timeZoneService: TimeZoneService, private readonly authService: AuthenticationService) {}

  ngOnInit() {
    this.account = this.authService.getCurrentAccount();
  }

  get date(): string {
    const { startDate, endDate } = this.event;
    const dateFormat = 'DD/MM/YYYY';

    const startDateISO = moment(startDate, dateFormat, true).toISOString();
    const endDateISO = moment(endDate, dateFormat, true).toISOString();

    const fromDateLocalized: string = this.timeZoneService.localiseDateISOStringByCustomFormat(startDateISO, dateFormat);
    const toDateLocalized: string = this.timeZoneService.localiseDateISOStringByCustomFormat(endDateISO, dateFormat);

    // both dates are equal e.g. there is no period, the event happens on a single day
    if (fromDateLocalized === toDateLocalized) {
      const eventDateMoment = moment(startDateISO).startOf('day');
      const todayMoment = moment().startOf('day');

      // Calculate difference in days
      const diffDays = todayMoment.diff(eventDateMoment, 'days');

      if (diffDays === 1) {
        return 'Yesterday';
      } else if (diffDays === 0) {
        return 'Today';
      } else if (diffDays === -1) {
        return 'Tomorrow';
      } else {
        return fromDateLocalized;
      }
    } else {
      return `${fromDateLocalized} to ${toDateLocalized}`;
    }
  }

  @HostListener('click')
  onClick(): void {
    this.eventSelected.emit(this.event);
  }
}
